import { render, staticRenderFns } from "./CompanyAdd.vue?vue&type=template&id=643ef56f&scoped=true&"
import script from "./CompanyAdd.vue?vue&type=script&lang=js&"
export * from "./CompanyAdd.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAdd.vue?vue&type=style&index=0&id=643ef56f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643ef56f",
  null
  
)

export default component.exports